import moment, { Moment } from 'moment/moment';

export const renderDateRangeLabel = (
    values: [Moment | null, Moment | null]
) => {
    const [startDate, endDate] = values;
    if (startDate && endDate) {
        return `${moment(startDate).format('DD-MM-YYYY')} - ${moment(endDate).format('DD-MM-YYYY')}`;
    }
    if (startDate) {
        return `${moment(startDate).format('DD-MM-YYYY')} - ___`;
    }
    if (endDate) {
        return `___ - ${moment(endDate).format('DD-MM-YYYY')}`;
    }
    return '___ - ___';
};
